module.exports = __webpack_public_path__ + "static/media/openBot.6ff9f906.wav";